// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { numberToFixed } from '@shared/ui-kit/utils';
import { type EsgAnalysis } from '@shared/data-access/interfaces/api/ai/esg-analysis';
import { TopEsgCompanies } from './top-esg-companies';
import { Exposure } from './exposure';
import { KpiBoxes } from '@shared/ui-kit/components';
import { type AssetsInfoResp } from '@shared/data-access/interfaces/api/ai/assets';
import { useEsg } from '../hooks';

export interface EsgScores {
  environmentScore: number;
  governanceScore: number;
  socialScore: number;
  totalEsgScore: number;
}

export interface EsgProps {
  esgAnalysis: EsgAnalysis;
  assetsInfo: AssetsInfoResp[] | null;
}

export const Esg = ({ esgAnalysis, assetsInfo }: EsgProps): JSX.Element => {
  const { esgKpiData, exposure, topAssets } = useEsg({ assetsInfo, esgAnalysis });

  return (
    <div>
      <div className="mt-2 grid grid-cols-4 gap-6">
        {esgKpiData.map(({ value, text, icon, color }) => (
          <KpiBoxes
            key={text}
            value={numberToFixed(value)}
            text={text}
            icon={icon}
            color={color}
          />
        ))}
      </div>
      <div className="risk-return-grid">
        <Exposure metrics={exposure} />
        <TopEsgCompanies assetsEsg={topAssets} />
      </div>
    </div>
  );
};
